
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'DeleteIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: '#EE3A3A',
        },
        className: {
            type: String,
            default: '',
        },
    },
})
